import React, {useEffect, useState, useCallback, useMemo, useRef} from 'react';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import "leaflet-rotatedmarker"; 
import './Map.css';
import ICON from '../../../assets/red car.png';

let mapView;

const Map =({assets, event})=>{
    const initialCenter = useMemo(() => [35.9135, 14.4213], []);
    const [mapCenter, setMapCenter] = useState(initialCenter)

    const markersGroupRef = useRef(L.featureGroup());

    console.log('Map component render - assets:', assets);
    console.log('Map component render - event:', event);

    const customIcon = useMemo(() => L.icon({
        iconUrl: ICON,
        iconSize: [32, 32],
        iconAnchor: [16, 16],
    }), []);

    //Set the leaflet map on first render
    useEffect(()=>{

        
        var container = L.DomUtil.get("mapDiv");
    
        if (container != null) {
            container._leaflet_id = null; 
        }
    
        mapView = L.map('mapDiv').setView(initialCenter, 10);
        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png').addTo(mapView);

        // Add test marker on a street in Malta
        const testLatLng = new L.LatLng(35.9178, 14.5019); // Street location in Sliema, Malta
        const testMarker = new L.marker(testLatLng, {
            draggable: false,
            interactive: false,
            rotationAngle: 0,
            rotationOrigin: 'center',
            id: 'test-red-car',
            icon: customIcon
        });
        testMarker.bindPopup('Test Red Car - Icon Working!');
        mapView.addLayer(testMarker);
    }, [customIcon])


    //Create a new marker (stable reference)
    const createMarker = useCallback((asset, latitude, longitude) => {
        console.log('createMarker', asset && asset.M_AssetID, latitude, longitude);
        if (!mapView) return null;
        const latlng = new L.LatLng(latitude, longitude);

        const marker = new L.marker(latlng, {
            draggable: false,
            interactive: false,
            rotationAngle: 0,
            rotationOrigin: 'center',
            id: asset.M_AssetID,
            icon: customIcon
        });

        marker.bindPopup(asset.M_Name2);
        marker.bindTooltip(asset.M_Name || asset.M_Name2 || '', {
            permanent: true,
            direction: 'right',
            offset: [12, 0],
            className: 'asset-label'
        });
        mapView.addLayer(marker);
        mapView.setView(latlng, 19);

        setMapCenter([latitude, longitude]);
        return marker;
    }, [customIcon]);

    //On event message, change marker position and rotation angle
    // useEffect(()=>{
    //     if(!mapView) return;
    //     if(event && event.speedInKmph>0){
    //         for (const m in mapView._layers) {
    //              if(mapView._layers[m] && mapView._layers[m].options && mapView._layers[m].options.id && mapView._layers[m].options.id.toUpperCase() === event.assetId.toUpperCase()){
    //                 const newLatLng = new L.LatLng(event.latitude, event.longitude);
    //                 mapView.setView(newLatLng);

    //                 mapView._layers[m].setLatLng(newLatLng);
    //                 if (typeof mapView._layers[m].setRotationAngle === 'function') {
    //                     mapView._layers[m].setRotationAngle(event.heading);
    //                 }
    //              }
    //          }
    //     }
    // }, [event])

    useEffect(() => {
    if (!mapView || !event) return;

    let markerFound = false;
    
    // Update the specific marker
    markersGroupRef.current.eachLayer((layer) => {
        if (layer.options.id && layer.options.id.toUpperCase() === event.assetId.toUpperCase()) {
            const newLatLng = new L.LatLng(event.latitude, event.longitude);
            layer.setLatLng(newLatLng);
            
            if (typeof layer.setRotationAngle === 'function') {
                layer.setRotationAngle(event.heading);
            }
            markerFound = true;
        }
    });

    // Instead of centering on ONE marker, fit the bounds of ALL markers
    if (markerFound) {
        const bounds = markersGroupRef.current.getBounds();
        if (bounds.isValid()) {
            // padding adds space so markers aren't touching the screen edges
            mapView.fitBounds(bounds, { padding: [50, 50], maxZoom: 16 });
        }
    }
}, [event]);


    //On asset list response, create a new marker for each asset
    useEffect(()=>{
        if(!mapView) return;
        if(assets && assets.length>0){
            // remove all existing markers (simple approach: remove layers that have id option)
            for (const key in mapView._layers) {
                const layer = mapView._layers[key];
                if (layer && layer.options && layer.options.id) {
                    mapView.removeLayer(layer);
                }
            }

            // add markers
            assets.forEach((p) => {
                if (p && p.M_LastPosition_Latitude && p.M_LastPosition_Longitude) {
                    createMarker(p, p.M_LastPosition_Latitude, p.M_LastPosition_Longitude);
                }
            });
        }
    }, [assets, createMarker])
    
    return <div id="mapDiv"/>;
}

export default Map;
